export const trustMetrics = [
  {
    value: "2,500",
    suffix: "+",
    label:
      "Free intakes completed from home — insurance pulled, financing arranged, care team connected",
  },
  {
    value: "94",
    suffix: "%",
    label:
      "AI-compiled medical files accepted on first submission — no back-and-forth, no delays",
  },
  {
    value: "40",
    suffix: "%",
    label:
      "Reduction in time from intake to walking comfortably — fewer bottlenecks, faster fit",
  },
  {
    value: "48",
    suffix: "hrs",
    label:
      "Average time from intake to having your full care team aligned and ready",
  },
];

export const features = [
  {
    icon: "ri-home-line",
    title: "Intake From Home — Free",
    description:
      "Complete your full intake in about 5 minutes, right from your couch. Always free for amputees — no cost, no catch. Just a warm, simple questionnaire that gets everything started.",
  },
  {
    icon: "ri-brain-line",
    title: "AI Handles the Paperwork",
    description:
      "Our AI compiles your responses into the medical-necessary language that physicians and prosthetists need. No more waiting on notes to line up — we format everything for them automatically.",
  },
  {
    icon: "ri-file-shield-line",
    title: "Insurance & Financing, Sorted",
    description:
      "AI pulls your insurance coverage details and arranges financing if needed. One of the biggest delays in getting a prosthetic is the administrative side — we handle all of it upfront, for free.",
  },
  {
    icon: "ri-hand-heart-line",
    title: "Find a Prosthetist or Keep Yours",
    description:
      "First time needing a prosthetist? We'll find you a great one nearby. Already have one you love? We work right alongside them. Either way, we make the entire process smoother for everyone involved.",
  },
  {
    icon: "ri-team-line",
    title: "Care Team Connected",
    description:
      "One of the biggest bottlenecks is getting the physician and prosthetist aligned on notes and timelines. Our AI connects them, streamlines their processes, and gets everyone on the same page — faster approvals, fewer delays.",
  },
];

export const testimonials = [
  {
    id: "1",
    name: "David Thompson",
    username: "@davidt",
    avatar:
      "https://readdy.ai/api/search-image?query=Middle%20aged%20man%20with%20warm%20friendly%20face%2C%20outdoor%20natural%20lighting%2C%20casual%20portrait%2C%20approachable%20and%20genuine%20expression%2C%20soft%20background%20blur%2C%20lifestyle%20portrait%20photography%2C%20warm%20tones&width=200&height=200&seq=avatar-1&orientation=squarish",
    content:
      "I already had a prosthetist I trusted, but the insurance and paperwork were dragging everything out. QuickProsthetics handled all of it — pulled my coverage, compiled the medical language, connected my doctor and prosthetist. What would have taken months took weeks. And it was free.",
  },
  {
    id: "2",
    name: "Maria Gonzalez",
    username: "@mariag",
    avatar:
      "https://readdy.ai/api/search-image?query=Hispanic%20woman%20with%20bright%20smile%2C%20warm%20outdoor%20portrait%2C%20natural%20sunlight%2C%20genuine%20happy%20expression%2C%20casual%20lifestyle%20photography%2C%20soft%20bokeh%20background%2C%20warm%20and%20inviting%20portrait&width=200&height=200&seq=avatar-2&orientation=squarish",
    content:
      "This was my first prosthetic and I had no idea where to start. QuickProsthetics found me a prosthetist in my area, handled the insurance, and even arranged financing. The AI compiled everything into language my doctor needed. I never paid a cent. Now I'm walking comfortably and it all felt so easy.",
  },
  {
    id: "3",
    name: "Robert Kim",
    username: "@robertk",
    avatar:
      "https://readdy.ai/api/search-image?query=Asian%20american%20man%20with%20confident%20smile%2C%20indoor%20warm%20portrait%2C%20soft%20studio%20lighting%2C%20friendly%20approachable%20expression%2C%20professional%20casual%20attire%2C%20clean%20lifestyle%20portrait%2C%20warm%20natural%20tones&width=200&height=200&seq=avatar-3&orientation=squarish",
    content:
      "The biggest delay in my case was getting my physician's notes to match what my prosthetist needed. QuickProsthetics connected them, the AI formatted everything, and suddenly a process that was stuck for weeks was moving. My prosthetist said it made her job so much easier.",
  },
  {
    id: "4",
    name: "Lisa Park",
    username: "@lisap",
    avatar:
      "https://readdy.ai/api/search-image?query=Asian%20woman%20with%20warm%20gentle%20smile%2C%20bright%20indoor%20portrait%2C%20natural%20window%20light%2C%20kind%20and%20genuine%20expression%2C%20casual%20lifestyle%20photography%2C%20soft%20background%2C%20warm%20inviting%20portrait&width=200&height=200&seq=avatar-4&orientation=squarish",
    content:
      "I switched to a new prosthetist through QuickProsthetics and the transition was seamless. The AI had already compiled my history, pulled my insurance, and prepped everything. My new prosthetist had a complete picture before I even walked in. Walking doesn't hurt anymore — and the whole process was free for me.",
  },
  {
    id: "5",
    name: "James Wilson",
    username: "@jamesw",
    avatar:
      "https://readdy.ai/api/search-image?query=Senior%20man%20with%20wise%20kind%20smile%2C%20outdoor%20portrait%2C%20golden%20hour%20lighting%2C%20warm%20genuine%20expression%2C%20lifestyle%20portrait%20photography%2C%20soft%20natural%20background%2C%20approachable%20and%20friendly&width=200&height=200&seq=avatar-5&orientation=squarish",
    content:
      "At 68, navigating insurance and medical paperwork was overwhelming. QuickProsthetics handled everything — pulled my Medicare coverage, connected my physician and prosthetist, and got me walking in half the time it would have taken on my own. My daughter helped me with the intake on the couch. Completely free.",
  },
  {
    id: "6",
    name: "Ashley Rivera",
    username: "@ashleyr",
    avatar:
      "https://readdy.ai/api/search-image?query=Young%20woman%20with%20bright%20genuine%20smile%2C%20warm%20indoor%20portrait%2C%20soft%20natural%20lighting%2C%20friendly%20and%20energetic%20expression%2C%20casual%20lifestyle%20photography%2C%20clean%20background%2C%20warm%20and%20inviting%20portrait&width=200&height=200&seq=avatar-6&orientation=squarish",
    content:
      "I loved my prosthetist but the administrative side was a nightmare — insurance, financing, getting notes aligned. QuickProsthetics took all of that off both our plates. They worked right alongside my existing clinic, handled the admin, and my prosthetist told me it cut her paperwork time in half. Free for me, easier for her. Everyone won.",
  },
];
